const ko = {
  button: {
    admissions: '입장',
    apply: '신청',
    notes: '메모',
    back: '뒤로',
    curatedTour: '추천 투어',
    exploreCampus: '내 주변 탐색하기',
    personalizedTour: '맞춤형 투어',
    home: '홈',
    requestInfo: '정보 요청',
    search: '검색',
    langSpanish: '스페인어로 보기',
    langEnglish: '영어로 보기',
    langFrench: '프랑스어로 보기',
    langKorean: '한국어로 보기',
    langChineseMandarin: '중국어로 보기',
    continue: '계속',
    cancel: '취소',
    resume: '재개',
    ok: '확인',
    emailMyTour: '나의 투어 이메일로 보내기',
    emailMyNotes: '나의 메모 이메일로 보내기',
    share: '공유',
    finishTour: '투어 종료',
    edit: '편집',
    add: '추가',
    save: '저장'
  },
  message: {
    tourTheCampus: '캠퍼스 투어',
    exploreCampus: '@:button.exploreCampus',
    notFound: '찾을 수 없음',
    personalizedTour: '@:button.personalizedTour',
    curatedTour: '@:button.curatedTour',
    nothingError: '표시할 내용 없음',
    viewNotes: '나의 메모',
    continueAbandonedTour: '이전 투어를 재개할까요?',
    about: '정보',
    location: '위치 | 위치',
    locations: '위치',
    stops: '중지',
    congratulations: '축하합니다!',
    firstName: '이름',
    lastName: '성',
    success: '성공',
    listenNow: '지금 듣기',
    restrictedPublicAccess: '대중 접근 제한됨'
  },
  socialMedia: {
    twitter: '트위터',
    facebook: '페이스북',
    email: '이메일',
    text: 'SMS/문자'
  },
  curatedTour: {
    description1: '여러분이 체험할 수 있도록 가장 일반적인 유형의 캠퍼스 투어 목록을 마련했습니다',
    description2: '아래에서 관심 분야를 선택하면 해당 투어 관심 분야와 관련된 건물 목록을 볼 수 있습니다',
    startTour: '투어 시작',
    saveTour: '투어 저장',
    viewRoute: '경로 보기'
  },
  personalizedTour: {
    title: '나의 투어 맞춤화하기',
    description1: '관심 분야에 따라 관심 장소를 선택하여 자신만의 캠퍼스 투어를 만들어 보세요.',
    description2: '아래 카테고리를 선택하여 맞춤형 투어를 만들어 보세요.',
    description3: '각 관심 장소를 목록에 추가한 후 “투어 만들기”를 선택하세요.',
    poiSelected: '관심 지점 선택됨',
    createTour: '투어 만들기',
    editList: '목록 편집하기',
    personalizeTour: '@:personalizedTour.title',
    personalizedTour: '나의 맞춤형 투어',
    createText1: '관심 분야에 따라 관심 장소를 선택하여 자신만의 캠퍼스 투어를 만들어 보세요.',
    createText2: '각 관심 장소를 목록에 추가한 후 “투어 만들기”를 선택하세요.',
    myTourText1: '귀하가 선택한 건물과 시설의 맞춤 목록입니다.',
    myTourText2: '빌딩 보기를 하면 자세한 정보를 확인할 수 있고 지도 아이콘을 클릭하면 길찾기가 가능합니다.',
    startTour: '@:curatedTour.startTour',
    saveTour: '@:curatedTour.saveTour',
    viewRoute: '@:curatedTour.viewRoute',
    success: '@:message.success',
    firstName: '@:message.firstName',
    lastName: '@:message.lastName',
    tourEmailed: '귀하의 투어를 이메일로 보냈습니다.'
  },
  exploreCampus: {
    description1: '캠퍼스 투어를 하면서 학생들을 위한 공용 구역인 학생식당, 경기장, 기숙사 등을 찾아보세요.',
    description2: '빌딩 보기를 하면 자세한 정보를 확인할 수 있고 지도 아이콘을 클릭하면 길찾기가 가능합니다.',
    listView: '목록 보기',
    mapView: '지도 보기'
  },
  notes: {
    title: '@:message.viewNotes',
    description: '투어를 하는 동안의 메모 모음. 이메일을 통해 공유하거나 볼 수 있습니다.',
    success: '@:message.success',
    notesEmailed: '귀하의 메모를 이메일로 보냈습니다.',
    firstName: '@:message.firstName',
    lastName: '@:message.lastName',
    enterYourNoteHere: '귀하의 메모를 여기에 입력하세요',
    edit: '@:button.edit',
    save: '@:button.save'
  },
  poiView: {
    description: '설명',
    directions: '길찾기',
    notes: '@:button.notes',
    openMap: '지도',
    startTour: '그곳에 데려다주세요',
    listStops: '목록 중지',
    listEmpty: '목록 비어 있음',
    priorStop: '이전 중지',
    nextStop: '다음 중지'
  },
  about: {
    termSentence1: '의미 있는 방식으로, 즉 자신의 생각대로 캠퍼스와 교감할 수 있습니다.',
    termSentence2: '주변 건물을 보거나, 권장하는 캠퍼스 투어를 하거나 자신만의 관심 분야에 따라 본인에게 맞춘 투어를 만들어 보세요.',
    createdPowered: '제작 및 지원:'
  }
}

export default ko
